export type EngineInitializer = () => Promise<void>;

let initializer: EngineInitializer | null = null;

export function setEngineInitializer(next: EngineInitializer): void {
    initializer = next;
}

export async function ensureEngineInitialized(): Promise<void> {
    if (!initializer) {
        throw new Error("Engine initializer is not configured");
    }
    await initializer();
}
